// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer .row {
  border-top: 2px solid black;
  margin-top: 15px;
  padding-top: 1.5rem;
  text-align: center;
}

footer .row a {
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/footer.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["footer .row {\n  border-top: 2px solid black;\n  margin-top: 15px;\n  padding-top: 1.5rem;\n  text-align: center;\n}\n\nfooter .row a {\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
